import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWeatherReNderprerje = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 31.197,
	height: 17.008,
	viewBox: "0 0 31.197 17.008",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_6634",
		"data-name": "Group 6634",
		transform: "translate(12892 12385)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9160",
				"data-name": "Path 9160",
				d: "M3.415,10.327a3.088,3.088,0,0,0-.774-.1,2.516,2.516,0,0,0-2.6,2.858c.732,4.141,13.4,4.03,12.949-.72a2.447,2.447,0,0,0-3.554-1.811,3.065,3.065,0,0,0-6.017-.224",
				transform: "translate(-12892 -12385)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9161",
				"data-name": "Path 9161",
				d: "M15.257,0A3.785,3.785,0,0,0,11.57,2.935,3.767,3.767,0,0,0,6.849,6.223a3.786,3.786,0,0,0-5.636,3.3c0,.121.007.24.018.358a3.42,3.42,0,0,1,1.41-.3c.11,0,.221.005.334.015a3.709,3.709,0,0,1,6.9.1,2.991,2.991,0,0,1,.664-.076,2.989,2.989,0,0,1,2.281,5.049,5.1,5.1,0,0,1-1.688,1.162,6.844,6.844,0,0,0,3.962,1.173c2.486,0,4.587-1.139,5.264-2.7a3.777,3.777,0,0,0,5.767-1.6c1.928-.537,3.3-1.924,3.3-3.552a2.923,2.923,0,0,0-.262-1.2,11.618,11.618,0,0,1-4.456.8h0c-3.224,0-6.669-1.086-7.1-3.511a2.94,2.94,0,0,1,.657-2.434,3.434,3.434,0,0,1,.489-.468A3.778,3.778,0,0,0,15.257,0Z",
				transform: "translate(-12892 -12385)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9162",
				"data-name": "Path 9162",
				d: "M24.6,0a3.067,3.067,0,0,0-2.988,2.379,3.036,3.036,0,0,0-.774-.1,2.516,2.516,0,0,0-2.6,2.858c.732,4.14,13.4,4.03,12.95-.722A2.447,2.447,0,0,0,27.631,2.6,3.064,3.064,0,0,0,24.6,0Z",
				transform: "translate(-12892 -12385)",
				fill: "#67a4fe"
			})
		]
	})
});
export { SvgWeatherReNderprerje as ReactComponent };
